import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaCredorEmpenhoInicio: [],
    buscaCredorEmpenhoSucesso: ['credorEmpenho'],
    buscaCredorEmpenhoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: null,
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaCredorEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaCredorEmpenhoInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarCredor(filtro)
            .then(response => dispatch(Creators.buscaCredorEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaCredorEmpenhoErro(error)))
    }
}

const buscaCredorEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaCredorEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaCredorEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.credorEmpenho, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CREDOR_EMPENHO_INICIO]: buscaCredorEmpenhoInicio,
    [Types.BUSCA_CREDOR_EMPENHO_ERRO]: buscaCredorEmpenhoErro,
    [Types.BUSCA_CREDOR_EMPENHO_SUCESSO]: buscaCredorEmpenhoSucesso,
})
